import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import MiranshApp from '../components/miransh/MiranshApp';

const MiranshPage = () => {
  const navigate = useNavigate();

  return (
    <div className="miransh-page">
      {/* Back Button */}
      {/* <button className="back-btn" onClick={() => navigate('/')} style={{ zIndex: 1000 }}>
        <ArrowLeft size={14} />
        All Hotels
      </button> */}
      <MiranshApp />
    </div>
  );
};

export default MiranshPage;
